import classNames from 'classnames';
import React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';

export const VeganProductInfoLabel = () => {
    return <div className={classNames('Label', 'Label__ProductInfoLabel', 'Label__Vegan')}>{getTranslation(keys['enum.infoBanner.vegan'])}</div>;
};
